import { styled, Box } from "@mui/material";

const FullScreenButtonRoot = styled(Box)(({ theme }) => ({
  width: 40,
  height: 40,
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  pointerEvents: "all",
  zIndex: 10,
  position: "absolute",
  top: theme.spacing(2),
  left: theme.spacing(2),
  borderRadius: theme?.borderRadius?.small,
  overflow: "hidden",
  transition: "all ease-in-out 0.5s",
  opacity: 1,
  "&:before": {
    content: '""',
    position: "absolute",
    width: "100%",
    height: "100%",
    zIndex: -1,
    background: theme?.palette?.companyColors?.neutral,
    // opacity: theme?.palette?.companyColors?.opacity75,
    borderRadius: theme?.borderRadius?.small,
  },
  [theme.breakpoints.up("xl")]: {
    right: theme.spacing(3),
    top: theme.spacing(3),
    width: 45,
    height: 45,
  },
  "&:hover": {
    "@media (hover: hover) and (pointer: fine)": {
      opacity: 1,
    },
  },
}));

const FullScreenButtonIcon = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "100%",
  borderRadius: 0,
  minWidth: 0,
  padding: 0,
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  margin: 0,
  transition: "all ease-in-out 0.5s",
  cursor: "pointer",
}));

export { FullScreenButtonRoot, FullScreenButtonIcon };
